import { useInfiniteQuery } from "@tanstack/react-query";
import { appointmentsV2InfiniteQueryOptions } from "queries/appointmentsV2QueryOptions";
import useFetchAllPagesForInfiniteQuery from "queries/useFetchAllPagesForInfiniteQuery";
import { useMemo } from "react";

const useAppointmentsInSeries = (
  patientUserId: string,
  appointmentSeriesId: string,
) => {
  const appointmentsForPatientQuery = useInfiniteQuery({
    ...appointmentsV2InfiniteQueryOptions({
      patientUserId,
      appointmentIsCancelledOrAbandoned: false,
    }),
    enabled: !!appointmentSeriesId && !!patientUserId,
  });
  useFetchAllPagesForInfiniteQuery(appointmentsForPatientQuery);

  const appointmentsForPatient = useMemo(
    () =>
      appointmentsForPatientQuery.data?.pages.flatMap(
        (page) => page.appointments,
      ) ?? [],
    [appointmentsForPatientQuery.data],
  );

  const appointmentsInSeries = useMemo(() => {
    if (!appointmentSeriesId) {
      return [];
    }

    return appointmentsForPatient.filter(
      (appointment) =>
        appointment.appointment_series_id === appointmentSeriesId,
    );
  }, [appointmentsForPatient, appointmentSeriesId]);

  const isSeriesLoaded =
    appointmentsForPatientQuery.isSuccess &&
    !appointmentsForPatientQuery.hasNextPage;

  return { appointmentsInSeries, isSeriesLoaded };
};

export default useAppointmentsInSeries;
